import styled from "styled-components";
export const SubStepList = styled.ol `
  list-style-type: none;
  display: flex;
  flex-direction: column;
`;
//# sourceMappingURL=styled.js.map